import IconButton from "@/components/icon-button";
import Loading from "@/components/loading/loading";
import TextInputWithIconComponent from "@/components/login/text-input-with-icon-component";
import {
  browserEnvironmentCheckUsecase,
  fetchUserInfoUsecase,
  loginUsecase,
  timeZoneCheckUsecase,
} from "@/init/initializeInstances";
import { useTranslation } from "@/utils/i18n/client";
import { Link } from "react-router";
import { useLoginViewModel } from "./login-view-model";
import styles from "./login-view.module.css";

export default function App() {
  //MARK:- Properties
  const { t } = useTranslation();
  const vm = useLoginViewModel({
    loginUsecase,
    fetchUserInfoUsecase,
    timeZoneCheckUsecase,
    browserEnvironmentCheckUsecase,
  });

  //MARK:- Render
  return (
    <div className={styles.loginContainer}>
      <div className={styles.loginBox}>
        <img
          className={styles.logo}
          src="/images/logoSalpha.png"
          alt="logo"
          width={6 * 16}
          height={4.8 * 16}
          style={{ width: "auto" }}
        />
        <form className={styles.loginForm} onSubmit={vm.handleSubmit}>
          {vm.errorMsg && <div className={styles.errorMessage}>{vm.errorMsg}</div>}
          <TextInputWithIconComponent
            id="email"
            divClassName={styles.inputFromTextOptionContainer}
            name="email"
            type="email"
            icon="/icon/login/login-at.svg"
            iconClassName={styles.icon}
            placeholder={t("login.email")}
            value={vm.email}
            onChange={(e) => vm.setEmail(e.target.value)}
            textClassName={styles.inputFromTextOption}
          />
          <TextInputWithIconComponent
            id="password"
            divClassName={styles.inputFromTextOptionContainer}
            name="password"
            type="password"
            icon="/icon/login/login-lock.svg"
            iconClassName={styles.icon}
            placeholder={t("login.password")}
            value={vm.password}
            onChange={(e) => vm.setPassword(e.target.value)}
            textClassName={styles.inputFromTextOption}
          />

          <div className={styles.loginOptionContainer}>
            <IconButton
              className={styles.rememberButton}
              textClassName={styles.loginOptionText}
              icon={
                vm.remember ? "/icon/login/login-check-square.svg" : "/icon/login/login-square.svg"
              }
              iconClassName={styles.rememberButtonIcon}
              alt="check icon"
              text={t("login.remember")}
              iconLocate="left"
              onClick={() => vm.handleRemember()}
            />
            <Link to="/find-password/request-link" className={styles.loginOptionText}>
              {t("login.forgotPassword")}
            </Link>
          </div>

          <button type="submit" className={styles.submitButton} disabled={vm.isLoading}>
            {t("login.signIn")}
          </button>
          {/* <button className={styles.signUpButton} onClick={() => navigate("/signup")}>
              {t("login.signUp")}
            </button> */}
        </form>
        <div className={styles.warningInfoContainer}>
          <img src="/icon/login/gray-warning.svg" alt="warning" width={16} height={16} />
          <span className={styles.warningInfoText}>
            <div>{t("login.warning.registeredUsersOnly")}</div>
            <div>{t("login.warning.monitoringAndRecording")}</div>
            <div>{t("login.warning.loginAgreement")}</div>
          </span>
        </div>
      </div>
      {vm.isLoading && <Loading />}
    </div>
  );
}
